/**
 * Levenshtein distance
 * @param {string} string1
 * @param {string} string2
 * @returns {number}
 */
export default (string1, string2) => {
	const sourceString = String(string1);
	const targetString = String(string2);

	if (sourceString.length === 0) {
		return targetString.length;
	} else if (targetString.length === 0) {
		return sourceString.length;
	} else {
		const array = [];
		const array1 = [];

		// Create matrix rows from sourceString
		for (let index = 0; index <= sourceString.length; index++) {
			array.push([index]);
		}
		// Create matrix columns from targetString
		for (let index = 0; index <= targetString.length; index++) {
			array1.push(index);
		}

		// Construct en empty matrix
		array[0] = array1;

		// Fill in the matrix
		for (let columnIndex = 1; columnIndex <= targetString.length; columnIndex++) {
			for (let rowIndex = 1; rowIndex <= sourceString.length; rowIndex++) {

				// The cell immediately above plus 1
				const above = array[rowIndex - 1][columnIndex] + 1;
				// The cell immediately to the left plus 1
				const left = array[rowIndex][columnIndex - 1] + 1;
				// The cell diagonally above and to the left plus the cost: d[i-1,j-1] + cost. If sourceString[i] equals targetString[j], the cost is 0. If sourceString[i] doesn't equal targetString[j], the cost is 1.
				const diagonal = array[rowIndex - 1][columnIndex - 1] + (sourceString[rowIndex - 1] === targetString[columnIndex - 1] ? 0 : 1);

				// Set cell d[i,j] of the matrix equal to the minimum of above, left and diagonal
				array[rowIndex][columnIndex] = Math.min(above, left, diagonal);
			}
		}

		/*
		 * The distance is found in cell d[n,m].
		 * ------
		 * Example
		 * ------
		 * c o
		 * 0 1 2
		 * c 1 0 1
		 * o 2 1 0
		 * m 3 2 1
		 */
		return array[sourceString.length][targetString.length];
	}
};
